import React from 'react';

export const DTour = () => {
	return (
		<div style={{ position: 'relative', overflow: 'hidden' }}>
		<a href={"https://yandex.ru/maps/org/akvarel/49546303248/?utm_medium=mapframe&utm_source=maps"} style={{ color: '#eee', fontSize: 12, position: 'absolute', top: 0 }}>
			Акварель
		</a>
		<a href={"https://yandex.ru/maps/16/yaroslavl/category/kitchen_furniture/184107873/?utm_medium=mapframe&utm_source=maps"} style={{ color: '#eee', fontSize: 12, position: 'absolute', top: 14 }}>
			Мебель для кухни в Ярославле
		</a>
		<a href={"https://yandex.ru/maps/16/yaroslavl/category/closets/184107887/?utm_medium=mapframe&utm_source=maps"} style={{ color: '#eee', fontSize: 12, position: 'absolute', top: 28 }}>
			Шкафы-купе в Ярославле
		</a>
		<iframe src="https://yandex.ru/map-widget/v1/-/CCUZZXGCcC" width={'100%'} height={400} style={{ position: 'relative' }}></iframe>
	</div>
	);
}